import { Outlet } from 'react-router-dom';
import isMobile from 'is-mobile';
import QRCode from 'react-qr-code';
import { Text, Title } from '~components';
import { ReactComponent as QRCodeIcon } from '~assets/icons/user.svg';
import { ReactComponent as HouseLocationIcon } from '~assets/icons/house-location.svg';
import { ReactComponent as SelfieIcon } from '~assets/icons/selfie.svg';
import Card from './Card';

import * as styled from './styled';

function TransshipmentDesktopGuard() {
  if (!isMobile() && process.env.REACT_APP_ENVIROMENT === 'production') {
    return (
      <styled.Layout>
        <styled.Wrapper>
          <styled.TextsWrapper>
            <Title>Envio de documentos e selfie</Title>
            <Text color="neutral-strong">
              Para concluir essa etapa, acesse o link enviado por SMS direto do
              seu aparelho celular. Por lá, você vai enviar:
            </Text>

            <styled.List>
              <styled.ListItem>
                <QRCodeIcon />
                <Text>Um documento de identificação (RG ou CNH);</Text>
              </styled.ListItem>
              <styled.ListItem>
                <HouseLocationIcon />
                <Text>Um comprovante de residência;</Text>
              </styled.ListItem>
              <styled.ListItem>
                <SelfieIcon />
                <Text>Uma foto do rosto (selfie)</Text>
              </styled.ListItem>
            </styled.List>

            <Card />
          </styled.TextsWrapper>

          <div>
            <styled.QRCodeWrapper>
              <QRCode value={document.URL} />
            </styled.QRCodeWrapper>
          </div>
        </styled.Wrapper>
      </styled.Layout>
    );
  }

  return <Outlet />;
}

export default TransshipmentDesktopGuard;
